import React from "react";
import { ProductVariant } from "../../../actions/types";
import { useDispatch, useSelector } from "react-redux";
import { selectVariant, setSelectedVariant } from "../products/productSlice";

type VariantProps = {
  variant: ProductVariant;
  index: number;
};

declare function prefixURL(url: string): string;

const Variant = ({ variant, index }: VariantProps) => {
  const currentVariant = useSelector(selectVariant);
  const dispatch = useDispatch();
  // TODO.DW
  const fieldName = `standalone_product[variant_id]`,
    fieldId = `variant-${variant.id}`;

  const toggleChecked = () => {
    dispatch(setSelectedVariant(variant));
  }

  const isThisVariantSelected = currentVariant && currentVariant.id === variant.id;
  return (
    <div className="row mb-1">
      <div className={`col-12 pt-2 d-flex`}>
        <div className={`form-check align-self-center`}>
          <input
            type="radio"
            onChange={() => toggleChecked()}
            className="form-check-input"
            name={fieldName}
            id={fieldId}
            checked={isThisVariantSelected}
            value={variant.id}
          />

          <label className={`form-check-label`} htmlFor={fieldId}>
            {variant.label}
          </label>
        </div>
      </div>
    </div>
  );
};

export default Variant;
